import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './NotificationBanner.less';

export const NOTIFICATION_TYPE = {
    ERROR: 'error',
    ERROR_FILL: 'error_fill',
    SUCCESS: 'success',
    WARNING: 'warn', // This warning is filled with orange
    WARNING_OUTLINE: 'warning_outline' // This warning is not filled with any color
};

export const BANNER_STYLE = {
    DEFAULT: '',
    LIGHT_BG: 'light-bg'
};

const getNotificationClass = (type, useVX = false) => {
    const ret = [type];

    if (useVX) {
        switch (type) {
            case NOTIFICATION_TYPE.ERROR:
            case NOTIFICATION_TYPE.ERROR_FILL:
                ret.push('vx_alert-critical');
                break;
            case NOTIFICATION_TYPE.WARNING:
                ret.push('vx_alert-warning');
                break;
            case NOTIFICATION_TYPE.SUCCESS:
                ret.push('vx_alert-success');
        }
    }

    return ret.join(' ');
};

/**
 * This Component is used to display banner on top of the page based on condition
 */
export class NotificationBanner extends Component {
    static propTypes = {
        bannerStyle: PropTypes.oneOf(Object.values(BANNER_STYLE)),
        className: PropTypes.string,
        condensed: PropTypes.bool,
        message: PropTypes.string.isRequired,
        iconClasses: PropTypes.string,
        id: PropTypes.string,
        type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPE)).isRequired,
        useVX: PropTypes.bool
    };

    static defaultProps = {
        bannerStyle: BANNER_STYLE.DEFAULT,
        className: '',
        condensed: false,
        iconClasses: '',
        useVX: false
    };

    render() {
        const {
            bannerStyle,
            className,
            condensed,
            message,
            iconClasses,
            id,
            type,
            useVX
        } = this.props;

        const wrapperClasses = [
            'NotificationBanner',
            bannerStyle,
            condensed ? 'condensed' : '',
            getNotificationClass(type, useVX),
            useVX ? 'vx_alert' : '',
            className
        ];

        const iconWrapperClasses = [
            'NotificationBanner-icon',
            iconClasses
        ];

        const textWrapperClasses = [
            'NotificationBanner-message',
            useVX ? 'vx_alert-text' : ''
        ];

        return (
            <div
                id={id}
                className={wrapperClasses.join(' ')}
                role="alert"
            >
                { !useVX && <span className={iconWrapperClasses.join(' ')} /> }
                <p className={textWrapperClasses.join(' ')}>{message}</p>
            </div>
        );
    }
}

export default NotificationBanner;
